import React from "react";

const Aboutpatnersectionfirst = () => {
  return (
    <div id="hs_cos_wrapper_widget_1719384527279" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" style={{ background: '#fff', justifyContent: 'center', width: '100%', marginTop: '-20px' }}>
      <style>
        {`
          .text-container {
            padding: 0;
          }

          .editor-wrapper {
            margin: 20px 0;
          }

        //   .container {
        //     max-width: 1200px;
        //     margin: 0 auto;
        //     padding: 20px;
        //   }

          .editor-wrapper p {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
          }

          .editor-wrapper strong {
            font-weight: bold;
          }

          .editor-wrapper img {
            max-width: 100%;
            height: auto;
          }

          .editor-wrapper img[src*="box-mosule-img.png"] {
            margin-top: 20px;
          }
        `}
      </style>
      <br></br>
      <h1 style={{ marginLeft: '150px', textAlign: 'center' }}>Our<span style={{ color: 'rgb(15 128 155)' }}> Patners</span></h1>
      <div className="row text-container widget_1719384527279" style={{ width: '100%', justifyContent: "center" }}>

        <div className="editor-wrapper">
          <div className="container">
            <p style={{ textAlign: 'justify' }}>
            Our strategic partnerships bolster our commitment to innovation and excellence. By collaborating with industry leaders and cutting-edge innovators, we stay at the forefront of technological advancements, ensuring that we deliver transformative solutions that meet the evolving needs of our customers and the world.
            </p>
         
            <p>

            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutpatnersectionfirst;
